<script setup></script>

<template>
  <div class="message-container">
    <div class="role-image">!</div>

    <div class="text">Une erreur s'est produite, veuillez réessayer.</div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.message-container {
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;
  align-items: center;

  > .role-image {
    width: 24px;
    height: 24px;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    flex-shrink: 0;
    background: colors.$red-color;
    color: colors.$white-color;
    font-weight: bold;
  }

  > .text {
    display: flex;
    width: 100%;
    font-style: italic;
    opacity: 0.6;
  }
}
</style>
